import { redirect, useParams } from "react-router";

import type { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetVoucherEditPageParams = () => {
	const { hotelID, voucherID } = useParams<ParamParseKey<typeof PATHS.HOTEL.MARKETING.VOUCHER.EDIT>>();

	if (!hotelID || !voucherID) {
		redirect("/");
	}

	return { hotelID: hotelID!, voucherID: voucherID! };
};
